import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TimeLogApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectHoursSummaryWithPercentageDto } from '../../../commonTypes/timelog.types';
import { setCachedHoursSummary, selectCachedHoursSummary } from '../../../store/slices/projects.slice';

const useHttpGetProjectHoursSummary = (projectId: string, enabled: boolean = true) => {
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const dispatch = useDispatch();
    const cachedData = useSelector(selectCachedHoursSummary(projectId));
    const [data, setData] = useState<ProjectHoursSummaryWithPercentageDto | null>(cachedData || null);
    const [isReady, setIsReady] = useState(false);

    const getSummary = (projectIdd: string) => {
        if (!projectIdd) {
            setIsReady(true);
            return;
        }

        const { exec, abort } = timeLogApi.getProjectHoursSummary({
            query: { projectId: projectIdd },
            onSuccess: res => {
                dispatch(setCachedHoursSummary({ projectId: projectIdd, data: res.body }));
                setData(res.body);
                setIsReady(true);
            },
            onError: error => {
                console.error('Error fetching project hours summary:', error);
                setIsReady(true);
            },
        });

        exec();
        return abort;
    };

    useEffect(() => {
        if (!enabled) {
            setIsReady(true);
            return;
        }

        if (cachedData) {
            setData(cachedData);
            setIsReady(true);
            return;
        }

        if (projectId) {
            getSummary(projectId);
        }
    }, [projectId, enabled, cachedData]);

    return { data, isReady, getSummary };
};

export default useHttpGetProjectHoursSummary;
